module.exports = __webpack_public_path__ + "img/2020_20161016_170858.99cf3be2.jpg";